import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'active',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `active`,
    method: 'get',
    params: queriesParams
  })
}

export function fetchFilteredForGarage(queriesParams) {
  return request({
    url: 'os-list-active-garage',
    method: 'get',
    params: queriesParams
  })
}

export function fetchFilteredForOs(queriesParams) {
  return request({
    url: 'os-list-active',
    method: 'get',
    params: queriesParams
  })
}

export function getAllAvailableToChange(queriesParams) {
  return request({
    url: 'list-active-available-change',
    method: 'get',
    params: queriesParams
  })
}

export function exchangeActive (data) {
  return request({
    method: 'post',
    url: 'exchange-active',
    data
  })
}

export function addActiveInOs (data) {
  return request({
    method: 'post',
    url: 'add-active-in-os',
    data
  })
}

export function removeActiveInOs (data) {
  return request({
    method: 'post',
    url: 'remove-active-in-os',
    data
  })
}

export function create (active) {
  return request({
    method: 'post',
    url: 'active',
    data: active
  })
}

export function show (id) {
  return request({
    url: `active/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `active/${id}`,
    method: 'patch',
    data
  })
}

export function movementBatch (data) {
  return request({
    method: 'post',
    url: 'actives-movement-batch',
    data
  })
}

export function activesMovementReport(queriesParams) {
  return request({
    url: `actives-movement-report`,
    method: 'get',
    params: queriesParams
  })
}

export function fetchActivesMovementReportPDF(queriesParams) {
  return request({
    url: `actives-movement-report-pdf`,
    method: 'get',
    params: queriesParams
  })
}

export function fetchAllSimcard () {
  return request({
    url: 'simcards',
    method: 'get'
  })
}

export function linkTrackerAndSimcard (data) {
  return request({
    method: 'post',
    url: 'link-tracker-simcard',
    data
  })
}

export function loadActivesByService(queriesParams) {
  return request({
    url: 'load-actives-by-service',
    method: 'get',
    params: queriesParams
  })
}

export function linkActiveModelAndSimcard (data) {
  return request({
    method: 'post',
    url: 'link-active-model-simcard',
    data
  })
}

export function addTrackersBatch (data) {
  return request({
    method: 'post',
    url: 'add-trackers-batch',
    data
  })
}

export function addSimcardsBatch (data) {
  return request({
    method: 'post',
    url: 'add-simcards-batch',
    data
  })
}
